import React from "react";
import { MortgageComparisonWidget } from "../../../components/MortgageComparisonWidget";

export const getMortgageComparisonPanel = ({
  rateTypeDefault,
  repaymentPeriodDefault,
  propertyValueDefault,
  mortgageAmountDefault,
  initialPeriodDefault,
  interestOnlyDefault,
  buyToLetDefault,
  sortOptionDefault,
  showFilterPanel,
  showHeader,
  trustHeader,
  headerTitle,
  headerText,
  mortgagePurpose,
  lenderFilter,
  headerAnchor,
}: any) => (
  <MortgageComparisonWidget
    options={{
      initialPeriod: [1, 2, 3, 4, 5, 10],
      rateType: ["Fixed", "Variable", "Discount", "Tracker"],
      repaymentPeriod: [25, 50],
    }}
    defaults={{
      buyToLetDefault,
      initialPeriodDefault,
      interestOnlyDefault,
      mortgageAmountDefault,
      propertyValueDefault,
      rateTypeDefault,
      repaymentPeriodDefault,
      lenderFilter,
      sortOptionDefault,
    }}
    mortgagePurpose={mortgagePurpose}
    showFilterPanel={showFilterPanel}
    headerParams={
      {
        showHeader,
        trustHeader,
        headerTitle,
        headerText,
        headerAnchor,
      }
    }
  />
);
